import type { HttpService } from '@empathyco/playboard-core-domain'
import type { IndexClientAdapter } from '../adapter/interfaces'
import type { PlatformIndexClientEntity } from '../adapter/platform-index-client.adapter'
import type { IndexClientDTO } from '../models'
import type { IndexClientService } from './interfaces'
import { interpolate } from '@empathyco/x-adapter'
import { inject, injectable, named, optional } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { FeatureIdEnum } from '../enums'

@injectable()
export class PlatformIndexClientService implements IndexClientService {
  public constructor(
    @inject(TYPES.HttpService) protected httpService: HttpService<PlatformIndexClientEntity>,
    @inject(TYPES.IndexClientAdapter)
    protected adapter: IndexClientAdapter<PlatformIndexClientEntity | undefined>,
    @inject(TYPES.IndexUrl) protected url: string,
    @inject(TYPES.Endpoint)
    @named(FeatureIdEnum.INDEX)
    @optional()
    protected endpoint = '/clients{(/)id}',
  ) {}

  async read(id: IndexClientDTO['id']): Promise<IndexClientDTO> {
    try {
      const response = await this.httpService.get<PlatformIndexClientEntity>(
        this.buildRequestUrl({ id }),
        {
          addAccessToken: true,
        },
      )
      return this.adapter.decode(response.data)
    } catch (error) {
      throw this.adapter.decodeError(error)
    }
  }

  async create(payload: any): Promise<any> {
    const response = await this.httpService.post<PlatformIndexClientEntity>(
      this.buildRequestUrl(),
      {
        addAccessToken: true,
        body: payload,
      },
    )
    return this.adapter.decode(response.data)
  }

  private buildRequestUrl(parameters: Record<string, any> = {}): string {
    const url = `${this.url}${this.endpoint}`
    return interpolate(url, { ...parameters })
  }
}
